import { useTranslation } from "react-i18next";
import { ResultLayout } from "./ResultLayout";
import type { QualificationResult, WizardAnswers, Lang } from "@/lib/types";

export interface ResultViewProps {
  result: QualificationResult;
  answers: WizardAnswers;
  lang: Lang;
}

export function ResultView({ result, answers, lang }: ResultViewProps) {
  const { t } = useTranslation();

  switch (result.result_case) {
    case "A":
      return (
        <ResultLayout
          result={result}
          answers={answers}
          lang={lang}
          badgeLabelKey="result.A.badge"
          titleKey="result.A.title"
          subtitleKey="result.A.subtitle"
          badgeVariant="A"
          showTicket
          showDocuments
          primaryCta={
            result.calendly_url
              ? { label: t("result.cta_rdv"), href: result.calendly_url }
              : undefined
          }
        />
      );

    case "B":
      return (
        <ResultLayout
          result={result}
          answers={answers}
          lang={lang}
          badgeLabelKey="result.B.badge"
          titleKey="result.B.title"
          subtitleKey="result.B.subtitle"
          badgeVariant="B"
          showTicket
          showDocuments
          primaryCta={
            result.calendly_url
              ? { label: t("result.cta_rdv"), href: result.calendly_url }
              : undefined
          }
        />
      );

    case "C":
      return (
        <ResultLayout
          result={result}
          answers={answers}
          lang={lang}
          badgeLabelKey="result.C.badge"
          titleKey="result.C.title"
          subtitleKey="result.C.subtitle"
          badgeVariant="C"
          showTicket={false}
          showDocuments
          primaryCta={
            result.calendly_url
              ? { label: t("result.cta_rdv"), href: result.calendly_url }
              : undefined
          }
          secondaryMessage={
            <p className="mt-5 rounded-input border border-danger/30 bg-danger/5 p-3 text-caption text-danger">
              {t("result.C.no_ticket_note")}
            </p>
          }
        />
      );

    case "D": {
      const messageKey = result.educational_message_key ?? "";
      const educational = messageKey ? (t(messageKey, { defaultValue: "" }) as string) : "";
      return (
        <ResultLayout
          result={result}
          answers={answers}
          lang={lang}
          badgeLabelKey="result.D.badge"
          titleKey="result.D.title"
          subtitleKey="result.D.title"
          badgeVariant="D"
          showTicket={false}
          showDocuments={false}
          extraTopBlock={
            educational ? (
              <p className="mt-5 rounded-input bg-info/[0.08] p-4 text-body text-ink-soft">
                {educational}
              </p>
            ) : null
          }
          primaryCta={{ label: t("result.D.cta_veille") }}
        />
      );
    }
  }
}
